import Vue from "vue";
import Vuex from "vuex";
import { authModule } from "./auth";

Vue.use(Vuex);

type StringOrNull = string | null;
type NumOrNull = number | null;
type UserMessage = {
  bm: string;
  en: string;
} | null;

export default new Vuex.Store({
  state: {
    popUpMessage: "",
    participants: [] as any[],
    userMessage: null as UserMessage,
    userDetail: {
      isAuthenticated: false,
      id: null as NumOrNull,
      name: null as StringOrNull,
      category: null as StringOrNull,
      votes: [] as any[],
    },

    popupImageDetails: {
      imageUrl: null,
      imageName: null,
      participantName: null,
      id: null,
      description: null,
    },

    votedItemID: [] as any[],

    emailToBeVerified: null as StringOrNull,
    triggerredFromRegister: false,
  },

  mutations: {
    updatedVotedItem(state, { id }) {
      if (state.votedItemID.includes(id)) {
        state.votedItemID = state.votedItemID.filter((item) => {
          return item !== id;
        });
      } else {
        state.votedItemID = [...state.votedItemID, id];
      }
    },
    setPopupImageDetails(
      state,
      { imageUrl, imageName, participantName, id, description }
    ) {
      state.popupImageDetails = {
        imageUrl,
        imageName,
        participantName,
        id,
        description,
      };
    },

    setEmailToBeVerified(state, { email, isFromRegister = false }) {
      state.emailToBeVerified = email;
      state.triggerredFromRegister = isFromRegister;
    },

    clearPopupImageDetails(state) {
      state.popupImageDetails = {
        imageUrl: null,
        imageName: null,
        participantName: null,
        description: null,
        id: null,
      };
    },

    setPopUpMsg(state, msg) {
      state.popUpMessage = msg;
    },

    setUserMessage(state, value) {
      if (value) {
        const { bm, en } = value;
        state.userMessage = { bm, en };
      } else {
        state.userMessage = null;
      }
    },

    setUserDetail(state, details) {
      const { user_details, participant_details, votes_details } = details;

      state.userDetail = {
        isAuthenticated: true,
        id: user_details.id,
        name: user_details.name,
        category: user_details.category,
        votes: votes_details,
      };
      state.participants = participant_details;

      state.votedItemID = votes_details.map((item: any) => {
        return item.artwork_id;
      });
    },

    clearUserDetail(state) {
      state.userDetail = {
        isAuthenticated: false,
        id: null as NumOrNull,
        name: null as StringOrNull,
        category: null as StringOrNull,
        votes: [] as any[],
      };
      state.participants = [] as any[];
      state.votedItemID = [] as any[];
    },
  },
  actions: {},
  modules: {
    auth: authModule as any,
  },
});
